module.exports = __webpack_public_path__ + "static/media/valorant.6bd698a7.png";